import { getIconName } from "@/utils/mode-commande";

export const widgetPlanningProps = () => ({
  modesCommande: {
    type: Array,
    required: true
  },
  type: {
    type: String,
    required: false,
    default: ""
  },
  commune: {
    type: Object,
    required: false,
    default: () => {}
  },
  magasinName: {
    type: String,
    required: false,
    default: ""
  },
  magasin: {
    type: Object,
    required: false,
    default: () => []
  },
  isDispoCarrefour: Boolean,
  jourPremierCreneauCarrefour: {
    type: String,
    required: false,
    default: "lundi"
  }
});

export const useWidgetPlanning =  (props) => {
  const activeTab = ref(0)

  const mounted = () => {
    if (props.type && props.modesCommande.length > 0) {
      const typeIndex = props.modesCommande.findIndex(mdc => mdc.type === props.type);
      if (typeIndex >= 0) {
        activeTab.value = typeIndex;
      }
    }
  }

  const getIconNameForModeCommande = (type) => {
    return getIconName(type);
  }

  const setActiveTab = (id) => {
    activeTab.value = id
  }

  return {
    mounted,
    getIconNameForModeCommande,
    setActiveTab,
    activeTab
  }
};
